<ng-container *ngIf="permConfig.isEditAllowed">
    <div class="container-fluid">
        <app-page-title title="Edit Custom Report"></app-page-title>
        <form [formGroup]="customReportForm" (ngSubmit)="updateCustomReport()">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="reportType" class="form-label">Report Type <span
                                                class="mandatory">*</span></label>
                                        <ng-select id="reportType" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                            [items]="reportTypeList" bindLabel="name" [bindValue]="'name'"
                                            (change)="onReportTypeChange($event)" formControlName="ddlReportType"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customReportForm.get('ddlReportType').touched) && customReportForm.get('ddlReportType').errors}">
                                        </ng-select>
                                        <div *ngIf="(isFormSubmitted || customReportForm.get('ddlReportType').touched) && customReportForm.get('ddlReportType').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="customReportForm.get('ddlReportType').errors.required">Type is
                                                required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="mb-2">
                                        <label for="reportName" class="form-label">Report Name
                                            <span class="mandatory">*</span>
                                        </label>
                                        <input type="text" class="form-control form-control-sm" id="reportName"
                                            formControlName="txtReportName"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || customReportForm.get('txtReportName').touched) && customReportForm.get('txtReportName').errors}">
                                        <div *ngIf="(isFormSubmitted || customReportForm.get('txtReportName').touched) &&   customReportForm.get('txtReportName').errors"
                                            class="invalid-feedback">
                                            <span *ngIf="customReportForm.get('txtReportName').errors.required">Name is
                                                required</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="columnDefs?.length > 0">
                <div class="col-4">
                    <div class="card">
                        <div class="card-header">
                            <label>
                                <input type="checkbox" [(ngModel)]="allColumnsSelected"
                                    (change)="onChangeSelectAllCheckbox($event)" [ngModelOptions]="{standalone: true}">
                                Select/Unselect All
                            </label>
                        </div>
                        <div class="table-responsive" style="max-height: 600px; overflow-y: auto;">
                            <table class="table table-bordered table-sm m-0">
                                <thead class="table-light">
                                    <tr>
                                        <th>Select</th>
                                        <th>Column Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let colDef of columnDefs">
                                        <td>
                                            <input type="checkbox" [(ngModel)]="colDef.visible"
                                                [ngModelOptions]="{standalone: true}"
                                                (ngModelChange)="onColumnVisibilityChanged()">
                                        </td>
                                        <td>{{ colDef.headerName }}</td>
                                    </tr>
                                </tbody>
                                <ng-template #noRecords>
                                    <tbody>
                                        <tr>
                                            <td colspan="2" class="text-center">
                                                <p class="text-muted mt-3">No records available.</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </ng-template>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="button-items">
                        <button type="submit" class="btn btn-primary w-sm">Update</button>
                        <a routerLink="/reports/customreports"><button type="button"
                                class="btn btn-secondary w-sm">Cancel</button></a>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isEditAllowed">
    <app-forbidden></app-forbidden>
</ng-container>